import examifyresult from "./assets/resulttest.svg";
// export const baseServiceUrl = "https://cbt.msqube.com/api/";

//export const baseServiceUrl = "http://15.206.132.5:8000/api/"; // dev server
// export const baseServiceUrl = "http://15.206.132.5:8000/api/"; //local server
//export const baseServiceUrl = "http://65.0.212.108:8065/api/"; // new PDF Work
//export const baseServiceOfflineUrl ="http://15.206.132.5:8000/api/";
// export const baseServiceUrl = "http://15.206.132.5:8000/api/";
// export const baseServiceOfflineUrl = "http://15.206.132.5:8000/api/";
//  export const baseServiceUrl = "http://65.0.212.108:8065/api/"; ////////////    Stage URL
// export const baseServiceUrl = "http://192.168.0.123:8000/api/";  ////////////    Bijoy  URL
//export const baseServiceUrl = "http://cbt.msq.ycsas.in/api/";  ////////////    Chaku's URL
// export const baseServiceUrl = "http://192.168.0.157:8010/api/";
//export const baseServiceUrl = "http://dev.msqube.com/qcbt/api/";
 //export const baseServiceUrl = "http://backend.local/api/";
 //export const baseServiceUrl = `${window.location.protocol}//${window.location.host}/api/`;
export const baseServiceUrl = `https://qcbt.in/api/`;
//export const baseServiceUrl = "http://10.70.0.2/api/";   // production
//export const proctorServiceURL = "http://45.114.178.184:8075/";// dev
//export const baseServiceUrl = "http://10.70.0.1:8070/api/"; 
export const proctorServiceURL = "https://qcbt.in/proctor/api/"; //prod  procotirng api url
export const ServerStatus: "OFFLINE" | "ONLINE" = "ONLINE";
export const urls = {
  adminLoginUrl: "users/login",
  getSubjectUrl: "common/domain/subject",
  cancelExamList: `admin/cancel_exam_paper/list`,
  getMarksDomainUrl: "common/domain/marks",
  getComplexityDomainUrl: "common/domain/complexity",
  getLanguageDomainUrl: "common/domain/language",
  getQuestionUrl: "admin/question/",
  createQuestionUrl: "admin/question/create",
  createExamUrl: "admin/exam/create",
  getAllExamUrl: "admin/exams",
  getExamByIdUrl: "admin/exams/",
  examStartUrl: "examinee/session/start",
  nextQuestionUrl: "examinee/session/nextQuestion",
  EndExamUrl: "examinee/session/submitExam",
  Examresult: "admin/examresult",
  SessionExamresult: "examinee/session/result",
  syncDownload: `common/sync/download`,
  uploadResultForOffline: `common/sync/uploadresults`,
  uniqueQuestionBankURL: `admin/qsnbank`,
  examiniResult: `examinee/session/result`,
  candidateExamConducted: `examinee/sess/userexamlist`,
  examiniResultSummary: `examinee/result/summary`,
  getExamGroupList: `examinee/userwise/exam_group_list`,
  examineeResult: `examinee/session/result`,
  examViewPDF: `report/candidate/examreportpdf`,
  resumeExam: `examinee/session/resume`,
  createScrutiny: `scrutiny/create_scrutiny`,
  scrutinyListing: `scrutiny/scrutiny_listing`,
  loginUserTypesByEmail: `users/orgdetailsbyemail`,
  faceVerificationURL: `examinee/face/verify`,
  proctorGenerateToken: `qcbt-proctor/generate-token/`,
  processProctorFrame: `qcbt-proctor/process-frame/`,
  contactUs: `admin/contact_us`,
};

export const sidebarDetails: Array<any> = [
  {
    sideBarurl: examifyresult,
    type: "result",
    sidebarText: "Examination Result",
    navURL: `/dashboard/examinee-portal/examinee-result`,
    nestedMenu: [],
  },
  // {
  //   sideBarurl: scrutiny,
  //   sidebarText: "Scrutiny",
  //   navURL: [
  //     `/dashboard/examinee-portal/scrutiny`,
  //     `/dashboard/examinee-portal/create-scrutiny`,
  //   ],
  //   adjacentMenu: ["/dashboard/examinee-portal/create-scrutiny"],
  //   nestedMenu: [],
  // },
];

export const DomainTypesList = [
  {
    key: "subject",
    label: "Subjects",
  },
  {
    key: "marks",
    label: "Marks",
  },
  {
    key: "complexity",
    label: "Complexity",
  },
  {
    key: "language",
    label: "Language",
  },
];

export const DomainTypeColumnList = [
  {
    domainKey: "subject",
    columns: [
      {
        field: "domain_key",
        headerName: "Subject Key",

        flex: 1,
        headerAlign: "center",
      },
      {
        field: "domain_value",
        headerName: "Subject Name",
        flex: 1,

        headerAlign: "center",
      },
    ],
  },
  {
    domainKey: "marks",
    columns: [
      {
        field: "domain_key",
        headerName: "Marks Key",

        headerAlign: "center",
        flex: 1,
      },
      {
        field: "domain_value",
        headerName: "Marks",
        flex: 1,

        headerAlign: "center",
      },
    ],
  },
  {
    domainKey: "complexity",
    columns: [
      {
        field: "domain_key",
        headerName: "Complexity Key",

        headerAlign: "center",
        flex: 1,
      },
      {
        field: "domain_value",
        headerName: "Complexity Name",
        width: 200,

        headerAlign: "center",
        flex: 1,
      },
    ],
  },
  {
    domainKey: "language",
    columns: [
      {
        field: "domain_key",
        headerName: "Language Key",

        headerAlign: "center",
        flex: 1,
      },
      {
        field: "domain_value",
        headerName: "Language Name",
        width: 200,

        headerAlign: "center",
        flex: 1,
      },
    ],
  },
];

export enum DomainEnum {
  LANGUAGE = "language",
  COMPLEXITY = "complexity",
  MARKS = "marks",
  SUBJECT = "subject",
}

export const ALPHABETS = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export const submissionExamContentForNotReview = {
  title: `Confirm Submission`,
  subtitle: `Are you sure you want to submit your answer`,
  desc: `Once submitted, your exam will complete and you will not be able to make any changes to your answers.`,
};

export const submissionExamContentForReview = {
  title: `Confirm Submission`,
  subtitle: `Are you sure you want to submit your answer`,
  // desc: `Once submitted, you will not be able to make any changes to your answers.`,
  desc: `Once submitted, you will not be able to make any changes.`,

  subDesc: ``,
  actionText: `Click "Yes" to  complete your exam or "No" to go back and review your answers.`,
};

export enum ANSWERSTATUSENUM {
  REVIEW = "REVIEW",
  ATTEMPT = "ATTEMPT",
  SKIP = "SKIP",
}

export const submissionCaseForTimesUp = {
  title: `Time's up!`,
  subtitle: `Your session is over, please submit your answers`,
};

export const Utilfilesizes = (bytes: any, decimals: number = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
export const allowedExtensions = ["pdf"];

//  ****************************************************** Notification Option **************************************************** //
export const NotificationOptions: any = {
  body: "Notification Body",
  icon: "/alert-icon-red-11-removebg-preview.png",
  dir: "ltr",
};

export const visibilityDownTime = 5;
export const visibilityDownNotificationIntervalTime = 2;

export enum SubmissionStatusEnum {
  TIME_OUT = "TIME_OUT",
  SUBMITTED = "SUBMITTED",
  ILLEGAL = "ILLEGAL",
  NOT_SUBMITTED = "NOT_SUBMITTED",
}

export const finalStatus = [
  {
    title: `Congratulations`,
    subtitle: `You have successfully completed the exam`,
    status: SubmissionStatusEnum.SUBMITTED,
  },
  {
    title: `Exam Submitted`,
    subtitle: `Suspicious activity has been detected in your application, and your exam has been automatically submitted. Please contact your center administrator for further assistance.`,
    status: SubmissionStatusEnum.ILLEGAL,
  },
  {
    title: `Exam Submitted`,
    subtitle: `Your time limit has been exceeded, and the exam has been automatically submitted. For further assistance, please contact your center administrator.`,
    status: SubmissionStatusEnum.TIME_OUT,
  },
];

export const examImagesForSlide = [
  "/exam_image2.jpeg",
  "/exam_image4.jpeg",
  "/exam_image5.jpg",
  "/exam_image6.jpg",
  "/exam_image7.jpeg",
  "/exam_image8.jpg",
  "/exam_image9.jpeg",
  "/exam_image11.jpeg",
  "/exam_image12.jpg",
  "/exam_image13.jpg",
  "/exam_image14.jpeg",
  "/exam_image15.jpg",
  "/exam_image16.jpg",
];

export const proctoringGapInMinute = 2;
